// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1XsIr","label":"Category_label__38Dkf","content":"Category_content__Q8NHh","header":"Category_header__1HsOi","location":"Category_location__ey53B"};